import {
  ButtonType,
  CovButton,
  CovToast,
  CovUploader,
  ToastStyle,
  ToastType,
} from "@cx-component-library/react-components";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  ALLOWED_UPLOAD_FORMATS,
  MAX_UPLOAD_FILE_SIZE,
  useImageUpload,
} from "./useImageUpload";

export const ImageUploadPanel = () => {
  const { t } = useTranslation();
  const { handleFilesDropped, handleFileError, toastMessage, clearToast } =
    useImageUpload();

  return (
    <Box
      sx={{
        padding: {
          xs: "var(--spacing32, 32px) var(--spacing16, 16px)",
          md: "var(--spacing32, 32px) var(--spacing88, 88px)",
        },
        "& .drop-space-content": { alignItems: "center" },
      }}
    >
      <CovUploader
        maxFileSize={MAX_UPLOAD_FILE_SIZE}
        allowedFormats={ALLOWED_UPLOAD_FORMATS}
        allowedFileExtensions=".png,.jpg,.jpeg,.webp"
        onFilesDropped={handleFilesDropped}
        onFileError={handleFileError}
        textContent={
          <Box sx={{ textAlign: "center" }}>
            <Typography
              sx={{
                fontSize: "var(--body-b1-16-regular-size, 16px)",
                fontWeight: 700,
                color: "var(--alias-text-on-white-primary)",
                marginBottom: "var(--spacing4, 4px)",
              }}
            >
              {t("ldp_explore_image_upload_title")}
            </Typography>
            <Typography
              sx={{
                fontSize: "var(--body-b2-14-regular-size, 14px)",
                color: "var(--alias-text-on-white-secondary)",
              }}
            >
              {t("ldp_explore_image_upload_subtitle")}
            </Typography>
            <div style={{ marginTop: "var(--spacing14, 14px)" }}>
              <CovButton buttonType={ButtonType.PRIMARY}>
                {t("ldp_explore_image_upload_browse")}
              </CovButton>
            </div>
          </Box>
        }
      />
      <CovToast
        visible={!!toastMessage}
        toastType={ToastType.DANGER}
        toastStyle={ToastStyle.FILLED}
        message={toastMessage ?? ""}
        hasCancelIcon
        autoHideDuration={6000}
        onClose={clearToast}
      />
    </Box>
  );
};
